module.exports = __webpack_public_path__ + "img/gg.6e34401c.svg";